import Head from 'next/head';

export type SeoPageDescriptionProps = {
  title: string;
  description: string;
};

export const SeoPageDescription = ({ title, description }: SeoPageDescriptionProps) => {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Head>
  );
};
